import React from "react";
import { useSelector } from "react-redux";
import Category from "../components/projects/Category";
import ConfirmationDialog from "../components/projects/ConfirmationDialog";
import ProjectModal from "../components/projects/ProjectModal";
import { useGetProjectsQuery } from "../features/projects/projectsApi";
import { useGetTeamsQuery } from "../features/teams/teamsApi";

export default function Projects() {
  //Modal Condition
  const { projectModal: openedModal, confirmationDialog: openedConfirmation } =
    useSelector((state) => state.projects);

  //Logged in User
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};

  //Queris
  const {
    data: projects,
    isLoading,
    isError,
  } = useGetProjectsQuery(loggedInUser?.email);

  const { data: teams } = useGetTeamsQuery(loggedInUser?.email);

  // Decide what to render
  let backlogWorks = [],
    readyWorks = [],
    doingWorks = [],
    reviewWorks = [],
    blockedWorks = [],
    doneWorks = [];

  if (!isLoading && !isError && projects?.length > 0) {
    projects
      .slice()
      .sort((a, b) => a.date - b.date)
      .forEach((project) => {
        const { status } = project;
        switch (status) {
          case "Backlog":
            backlogWorks.push(project);
            break;
          case "Ready":
            readyWorks.push(project);
            break;
          case "Doing":
            doingWorks.push(project);
            break;
          case "Review":
            reviewWorks.push(project);
            break;
          case "Blocked":
            blockedWorks.push(project);
            break;
          case "Done":
            doneWorks.push(project);
            break;
          default:
            break;
        }
      });
  }

  return (
    <>
      <div className="flex flex-col w-screen h-screen overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200">
        <div className="px-10 mt-6">
          <h1 className="text-2xl font-bold">Project Board</h1>
          {isLoading && !isError && (
            <h1 className="text-center text-2xl font-bold">Loading...</h1>
          )}
        </div>
        <div className="flex flex-grow px-10 mt-4 space-x-6 overflow-auto">
          <Category
            name="Backlog"
            quantity={backlogWorks?.length}
            works={backlogWorks}
            plus={true}
          />
          <Category
            name="Ready"
            quantity={readyWorks?.length}
            works={readyWorks}
          />
          <Category
            name="Doing"
            quantity={doingWorks?.length}
            works={doingWorks}
          />
          <Category
            name="Review"
            quantity={reviewWorks?.length}
            works={reviewWorks}
          />
          <Category
            name="Blocked"
            quantity={blockedWorks?.length}
            works={blockedWorks}
          />
          <Category
            name="Done"
            quantity={doneWorks?.length}
            works={doneWorks}
          />
        </div>
        <ProjectModal open={openedModal} teams={teams} />
        <ConfirmationDialog open={openedConfirmation} />
      </div>
    </>
  );
}
